var _meta;

import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageMetaTags } from "../../../tags";
import { useLocalizedHistory } from '../../../i18n';
import { PageErrorLayout } from '../../Layout';

var PageError404 = function PageError404() {
  var history = useLocalizedHistory();

  var _useTranslation = useTranslation(['dsPageError']),
      t = _useTranslation.t;

  var onClick = function onClick() {
    return history.push('/');
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageMetaTags, {
    title: t('404_TITLE')
  }, _meta || (_meta = /*#__PURE__*/React.createElement("meta", {
    name: "render:status_code",
    content: "404"
  }))), /*#__PURE__*/React.createElement(PageErrorLayout, {
    errorCode: 404,
    description: t('404_DESCRIPTION'),
    buttonText: t('404_BUTTON_TEXT'),
    onClick: onClick
  }));
};

export default PageError404;